export const validateHookForm = (values: any): any => {
  const errors = [];
  if (!values.password || !values.password.replace(/\s/g, '').length) {
    errors.push({
      name: 'password',
      type: '',
      message: 'Please enter password!'
    });
  } else if (
    !values.confirmPassword ||
    !values.confirmPassword.replace(/\s/g, '').length
  ) {
    errors.push({
      name: 'confirmPassword',
      type: '',
      message: 'Please enter confirm password!'
    });
  } else if (values.confirmPassword !== values.password) {
    errors.push({
      name: 'confirmPassword',
      type: '',
      message: 'Passwords are not match!'
    });
  }
  return errors;
};

export const validate = (values: any): any => {
  const errors = {
    email: '',
    password: '',
    confirmPassword: ''
  };
  if (!values.email || !values.email.replace(/\s/g, '').length) {
    errors.email = 'Please enter username!';
  } else if (!values.password || !values.password.replace(/\s/g, '').length) {
    errors.password = 'Please enter password';
  } else if (
    !values.confirmPassword ||
    !values.confirmPassword.replace(/\s/g, '').length
  ) {
    errors.confirmPassword = 'Please enter confirmed password';
  }
  return errors;
};

// Latest one - Oct 2020
export const validateWithHookForm = (values: any): any => {
  let errors: any = {
    password: '',
    confirmPassword: ''
  };
  if (!values.password || !values.password.replace(/\s/g, '').length) {
    errors.password = 'RESET_PASSWORD.NEW_PASSWORD_REQ';
  } else {
    const upperCaseRg = /[A-Z]/;
    const lowerCaseRg = /[a-z]/;
    const digitRg = /[0-9]/;
    const specialCaseRg = /\W|_/g;
    if (values.password.length < 8 || values.password.length > 15) {
      errors.password = 'RESET_PASSWORD.VALIDATIONS.LENGTH';
    } else if (!upperCaseRg.test(values.password)) {
      errors.password = 'RESET_PASSWORD.VALIDATIONS.UPPER_CASE_LETTER';
    } else if (!lowerCaseRg.test(values.password)) {
      errors.password = 'RESET_PASSWORD.VALIDATIONS.LOWER_CASE_LETTER';
    } else if (!digitRg.test(values.password)) {
      errors.password = 'RESET_PASSWORD.VALIDATIONS.DIGIT';
    } else if (!specialCaseRg.test(values.password)) {
      errors.password = 'RESET_PASSWORD.VALIDATIONS.SPECIAL_CHARACTERS';
    }
  }
  if (
    !values.confirmPassword ||
    !values.confirmPassword.replace(/\s/g, '').length
  ) {
    errors.confirmPassword = 'RESET_PASSWORD.CONFIRM_NEW_PASSWORD_REQ';
  }
  if (values.password !== values.confirmPassword) {
    errors.confirmPassword = 'RESET_PASSWORD.PASSWORDS_NOT_MATCH';
  }
  if (!errors.password && !errors.confirmPassword) {
    errors = {};
  }
  return errors;
};
